export const RegistrosActionTypes = {
  API_RESPONSE_SUCCESS: '@@registros/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@registros/API_RESPONSE_ERROR',

  LIST_REGISTROS: '@@registros/LIST_REGISTROS',
  ADD_REGISTRO: '@@registros/ADD_REGISTRO',

  GET_REGISTROS_FOR_EXCEL: '@@registros/GET_REGISTROS_FOR_EXCEL',
  GET_REGISTROS_FOR_EXCEL_RA: '@@registros/GET_REGISTROS_FOR_EXCEL_RA',
  GET_REGISTROS_IT_SEND_STAT: '@@registros/GET_REGISTROS_IT_SEND_STAT',
  GET_DATA_CHARTS: '@@registros/GET_DATA_CHARTS',
  GET_DATA_CHARTS_COMPARISONS: '@@registros/GET_DATA_CHARTS_COMPARISONS',

  RESET: '@@registros/RESET',
  RESET_ALL: '@@registros/RESET_ALL'

}
